class DateRangeService {
    private static _dateRangeList: Array<DateRange>;
    static get DatesRange() {
        if (!this._dateRangeList) {
            DateRangeService.Get();
        }
        return this._dateRangeList;
    }
    private static Get() {
        let url = urlConfigs.tabs + "GetDateRanges";
        let sucessCallback = function (data) {
            let list = createInstances(DateRange, data);

            DateRangeService._dateRangeList = list;
        };
        irGlobal.updateFromServer({},
            url,
            {},
            sucessCallback,
            function (textStatus, errorThrown, errorItem: IError) {
                errorItem.userMessage = "Failed to get date ranges";
                irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
            },
            true,
            "POST",
            true,
            null,
            null,
            false);
    }

    static get OnlySingleDates() {
        return DateRangeService.DatesRange.filter(x => x.validForSingleDate());
    }
}